import { Buffer } from 'buffer';
import { xchacha20poly1305 } from '@noble/ciphers/chacha';
import { utf8ToBytes } from '@noble/ciphers/utils';
import { randomBytes } from '@noble/ciphers/webcrypto/utils';
import { arrayBufferToBase64, ConstantsUtil, encryptDecrypt } from '@utils';
/**
 * Token creation helper.
 *
 * @author Ihar Kazlouski
 * @function tokenCreation
 * @category helpers
 * @return {string } token.
 */

var tokenCreation = function tokenCreation() {
  var password = sessionStorage.getItem(ConstantsUtil.localStorage.randomString);
  var encryptedFifthKey = sessionStorage.getItem(ConstantsUtil.localStorage.fifthKey);
  var encryptedClientNumber = sessionStorage.getItem(ConstantsUtil.localStorage.client);
  var fifthKey = encryptDecrypt(encryptedFifthKey || '', password || '');
  var clientNumber = JSON.parse(encryptDecrypt(encryptedClientNumber || '', password || ''));
  var currentDate = new Date();
  var nonce = randomBytes(24);
  var stringifyPayload = JSON.stringify({
    number: clientNumber.keyNumber,
    client: clientNumber.clientNumber,
    timestamp: currentDate.getTime(),
    nonce: arrayBufferToBase64(nonce)
  });
  var leftPart = btoa(stringifyPayload);
  var data = utf8ToBytes(leftPart);
  var stream_x = xchacha20poly1305(Buffer.from(fifthKey, 'base64'), nonce);
  var ciphertext = stream_x.encrypt(data);
  var lastSixteenBytes = ciphertext.slice(-16);
  var rightPart = arrayBufferToBase64(lastSixteenBytes);
  var token = leftPart + '.' + rightPart;
  return token;
};

export { tokenCreation };